module.exports = __webpack_public_path__ + "static/media/logo_sem_texto.b5e7ba3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_sem_texto.png
// module id = 711
// module chunks = 0